export class FolioFilter {
   tipoDteId: string;
   ambienteId: number;
   sucursalId: string;
   activo: boolean;
   emisorId: string;
   bloqueado?: boolean;
}
